import { toast } from "react-toastify";
import { requestBackendReportExport } from "./backendReportExport";

export const CAMPAIGN_LIST_COLUMN_ID_TO_API_KEY = {
  status: "status",
  name: "name",
  categories: "campaign_categories",
  targeting: "amz_targeting_type",
  portfolio: "amz_portfolio_name",
  budget: "daily_budget",
  "bid-strategy": "bidding",
  spends: "spends",
  dbr: "dbr",
  campaign_burn_rate: "campaign_burn_rate",
  orders: "orders",
  sale_value: "sale_value",
  roas: "roas",
  impressions: "impressions",
  clicks: "clicks",
  cpm: "cpm",
  ctr: "ctr",
  cpc: "cpc",
  cvr: "cvr",
  aov: "aov",
  acos: "acos",
};

export function getCampaignListVisibleColumnKeys(dataHeads = []) {
  return dataHeads
    .map((head) => CAMPAIGN_LIST_COLUMN_ID_TO_API_KEY[head.id] ?? head.id)
    .filter(Boolean);
}

function parseMetricRange(filter) {
  const min = isNaN(Number(filter.minRange)) ? 0 : Number(filter.minRange);
  const max =
    filter.maxRange === "" ||
    filter.maxRange === "-" ||
    isNaN(Number(filter.maxRange))
      ? null
      : Number(filter.maxRange);

  return { field: filter.id, min, max };
}

export function buildCampaignListExportQueryBody({
  startDate,
  endDate,
  campaignFiltering = [],
  statusTab,
  searchText = "",
  category = "",
  appliedFilterData = [],
  sortField = "spends",
  sortDescending = true,
}) {
  const metric_ranges = appliedFilterData
    .map(parseMetricRange)
    .filter(({ min, max }) => min !== 0 || max !== null);

  const status_tab =
    statusTab === "enabled-btn"
      ? "ENABLED"
      : statusTab === "PAUSED"
        ? "PAUSED"
        : "All";

  return {
    start_date: startDate,
    end_date: endDate,
    campaign_filtering: campaignFiltering,
    client_filters: {
      status_tab,
      search_text: searchText,
      category,
      metric_ranges,
      sort: {
        field: sortField,
        direction: sortDescending ? "desc" : "asc",
      },
    },
  };
}

export async function exportCampaignListReport({
  clientId,
  userPlatform,
  triggeredBy,
  totalCount,
  queryBody,
  visibleColumnKeys,
  setIsExporting = () => {},
  onExportSuccess = () => {},
}) {
  try {
    setIsExporting(true);

    await requestBackendReportExport({
      clientId,
      userPlatform,
      reportType: "CAMPAIGNS",
      totalCount,
      triggeredBy,
      queryBody,
      frontendConfig: {
        include_summary_row: true,
        columns: visibleColumnKeys,
      },
    });

    onExportSuccess();
  } catch (error) {
    console.error(error);
    toast.error(
      error?.response?.data?.message ??
        "Failed to submit campaign export request."
    );
  } finally {
    setIsExporting(false);
  }
}
